import { render, staticRenderFns } from "./TextIndexCardContainer.vue?vue&type=template&id=16695c36&scoped=true"
import script from "./TextIndexCardContainer.vue?vue&type=script&lang=js"
export * from "./TextIndexCardContainer.vue?vue&type=script&lang=js"
import style0 from "./TextIndexCardContainer.vue?vue&type=style&index=0&id=16695c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16695c36",
  null
  
)

export default component.exports